import styles from './Preview.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { useRouter } from 'next/router';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';

interface Props {
	url: string;
	children?: React.ReactNode;
}

export const Preview = ({ children, url }: Props) => {
	const { isPreview } = useRouter();
	const dictionary = useDictionaryContext();

	if (!isPreview) return <>{children}</>;

	return (
		<div className={styles.Preview}>
			<div className={styles.Preview_top}>
				<p>
					{dictionary.getPreview('InPreview')}
					<UI_Link className={styles.Preview_link} url={`/api/exitPreview?slug=${url}`}>
						{dictionary.getPreview('ExitPreview')}
					</UI_Link>
				</p>
			</div>
			<div className={styles.Preview_content}>{children}</div>
		</div>
	);
};
